import { useEffect } from 'react';

export const useAccordion = (el: React.MutableRefObject<null | HTMLElement>) => {
  useEffect(() => {
    const container = el.current;
    if (container) {
      const clickTargets = container.getElementsByTagName('header');

      const clickOutside = (e: Event) => {
        const outsideClick = !container.contains(e.target as HTMLElement);

        if (outsideClick) {
          Array.from(clickTargets).forEach(header => {
            if (header.classList.contains('open')) {
              header.classList.remove('open');
            }
          });
        }
      };

      const callback = (e: Event) => {
        e.stopImmediatePropagation();

        Array.from(clickTargets).forEach(header => {
          if (header.contains(e.target as HTMLElement) && header.classList.contains('open')) {
            header.classList.remove('open');
          } else if (header.contains(e.target as HTMLElement) && !header.classList.contains('open')) {
            header.classList.add('open');
          }
          if (!header.contains(e.target as HTMLElement) && header.classList.contains('open')) {
            header.classList.remove('open');
          }
        });
      };

      container.addEventListener('click', callback);
      document.addEventListener('click', clickOutside);

      return () => {
        container?.removeEventListener('click', callback);
        document.removeEventListener('click', clickOutside);
      };
    }
  }, [el]);
};
